import { PieChartBlock } from '../../viz.types';
import { getVizSeriesColor } from '../../viz.utils';

export interface PieChartSlice {
  name: string;
  value: number;
  fill: string;
  share: number | null;
}

export interface PieChartData {
  slices: PieChartSlice[];
  total: number;
}

export interface GetPieChartSlicesParams {
  slices: PieChartBlock['slices'];
  sliceColors: string[];
  sliceOpacities: number[];
}

export const getPieChartSlices = ({
  slices,
  sliceColors,
  sliceOpacities,
}: GetPieChartSlicesParams): PieChartData => {
  const total = slices.reduce((sum, slice) => sum + slice.value, 0);

  return {
    total,
    slices: slices.map((slice, index) => ({
      name: slice.label,
      value: slice.value,
      fill: getVizSeriesColor({ index, colors: sliceColors, opacities: sliceOpacities }),
      share: total > 0 ? slice.value / total : null,
    })),
  };
};
